import { GLOBAL_CONSTANTS } from 'assets/js/utils/constants'

const SELECTORS = {
  video: '.js-card-video',
  image: '.js-card-image',
  videoButton: '.js-card-video-button',
  videoButtonPlayIcon: '.js-card-video-button-play-icon',
  videoButtonPauseIcon: '.js-card-video-button-pause-icon'
}

class CardLegacy {
  constructor (element) {
    this.element = element
    this.emitter = GLOBAL_CONSTANTS.UTILS.EMITTER
    this.video = this.element.querySelector(SELECTORS.video)
    this.noAuto = this.video && this.video.dataset.noauto ? this.video.dataset.noauto : null
    this.image = this.element.querySelector(SELECTORS.image)
    this.videoButton = this.element.querySelector(SELECTORS.videoButton)
    this.videoButtonPlayIcon = this.element.querySelector(SELECTORS.videoButtonPlayIcon)
    this.videoButtonPauseIcon = this.element.querySelector(SELECTORS.videoButtonPauseIcon)
    this.init()
    this.isVideoPlaying = null
  }

  init () {
    if (this.video) {
      this.emitter.on(GLOBAL_CONSTANTS.EVENTS.REDUCED_MOTION_CHANGE, () => this.motionMethod())
    }

    this.setMedia()

    if (this.video) {
      this.video.onplaying = () => {
        this.handleVideoPlaying()
      }

      this.video.onended = () => {
        this.handleVideoPaused()
      }

      this.video.onpause = () => {
        this.handleVideoPaused()
      }
    }

    if (this.videoButton) {
      this.videoButton.onclick = (event) => this.handleVideoButtonClick(event)
    }
  }

  motionMethod() {
    if (this.video) { this.video.classList.remove(GLOBAL_CONSTANTS.CLASSES.SHOW) }
    this.setMedia()
  }

  setMedia() {
    const hasReducedMotionSet = document.documentElement.classList.contains('reduced-motion')

    if (this.video && !this.noAuto) {
      this.displayVideo({ autoplay: !hasReducedMotionSet })
    } else if (this.image) {
      this.displayImage()
    }
  }

  displayVideo({ autoplay }) {
    if (this.image) {
      this.image.classList.remove(GLOBAL_CONSTANTS.CLASSES.SHOW)
    }
    this.video.autoplay = autoplay
    this.video.load()
    this.video.classList.add(GLOBAL_CONSTANTS.CLASSES.SHOW)
  }

  handleVideoButtonClick(event) {
    event.preventDefault()
    if (this.isVideoPlaying) {
      this.video.pause()
    } else {
      this.video.play()
    }
  }

  handleVideoPaused() {
    this.isVideoPlaying = false
    if (this.videoButton) {
      this.videoButtonPlayIcon.classList.remove(GLOBAL_CONSTANTS.CLASSES.HIDE)
      this.videoButtonPauseIcon.classList.add(GLOBAL_CONSTANTS.CLASSES.HIDE)
      this.videoButton.ariaLabel = 'play video'
    }
  }

  handleVideoPlaying() {
    this.isVideoPlaying = true
    if (this.videoButton) {
      this.videoButtonPlayIcon.classList.add(GLOBAL_CONSTANTS.CLASSES.HIDE)
      this.videoButtonPauseIcon.classList.remove(GLOBAL_CONSTANTS.CLASSES.HIDE)
      this.videoButton.ariaLabel = 'pause video'
    }
  }

  displayImage() {
    if (this.video) {
      this.video.classList.remove(GLOBAL_CONSTANTS.CLASSES.SHOW)
    }
    this.image.classList.add(GLOBAL_CONSTANTS.CLASSES.SHOW)
  }
}

export default {
  selector: '.js-card',
  Source: CardLegacy
}
